<script>
import moment from 'moment'
import { mixin as clickaway } from 'vue-clickaway'
import { formatThousands } from '@/utils/helpers'
import infoIcon from '@/assets/images/icons/info.svg?inline'

export default {
  name: 'popup-penalties',
  components: {
    infoIcon
  },
  mixins: [
    clickaway
  ],
  props: {
    ids: {
      type: Object,
      default: () => ({}),
      required: true
    },
    storeModule: {
      type: String,
      required: true
    },
    target: {
      type: String,
      required: true
    },
    apiModuleName: {
      type: String,
      default: () => null,
      required: true
    },
    serviceName: {
      type: String,
      required: true
    },
    iconButton: {
      type: Boolean,
      default: () => true
    },
    wrapperClass: {
      type: String,
      default: () => null
    }
  },
  data: () => ({
    showContent: false,
  }),
  computed: {
    penalties() {
      return this.$store.getters[`${this.storeModule}/getServicePenalties`](this.target)
    },
    isLoading() {
      return this.penalties.isLoading
    },
    error() {
      return this.$store.getters[`${this.storeModule}/getServiceModuleErrors`](this.target)
    }
  },
  methods: {
    showPopup() {
      const { currency } = this.$store.getters['cart/getCartPrice']

      this.$store.dispatch(`${this.storeModule}/getServicePenalties`, {
        ids: {
          ...this.ids,
          currency
        },
        serviceName: this.serviceName,
        apiModuleName: this.apiModuleName,
        target: this.target
      })

      this.showContent = true
    },
    hidePopup() {
      this.$store.commit(`${this.storeModule}/updateServiceModuleIsLoading`, {
        status: true,
        target: `${this.target}.penalties`
      })

      this.showContent = false
    },
    formatDate: date => moment.unix(date).format('DD.MM.YYYY HH:MM'),
    formatThousands: number => formatThousands(number)
  }
}
</script>

<template>
  <div
    v-on-clickaway="hidePopup"
    class="cart__popup-penalties"
  >
    <span @click="showPopup">
      <infoIcon
        v-if="iconButton"
        fill="#55b7a1"
        class="cart__popup-penalties-btn"
        :class="{
          'cart__popup-penalties-btn--show-tooltip': !showContent
        }"
      />
      <slot
        v-else
      />
    </span>
    <div class="cart__popup-penalties-help">
      Нажмите, чтобы загрузить информацию по штрафам
    </div>
    <div
      v-if="showContent"
      class="cart__popup-penalties-content"
    >
      <b-loading
        :is-full-page="false"
        :active="isLoading"
      />
      <template v-if="!isLoading">
        <div v-if="error.hasError">
          <div
            v-for="(item, index) in error.errorsList"
            :key="index"
            class="cart__popup-penalties-content-item cart__popup-penalties-content-item--error"
          >
            <p>{{ item }}</p>
          </div>
        </div>
        <template v-else>
          <div
            v-for="(item, index) in penalties.collection"
            :key="index"
            class="cart__popup-penalties-content-item"
          >
            <p>
              {{ item.action }} c {{ formatDate(item.from) }}
              <span v-if="item.to"> по {{ formatDate(item.to) }}</span>
            </p>
            <p>{{ formatThousands(item.price.amount) }} {{ item.price.currency }}</p>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>